import { MenuItem, RouteTabConfig } from './tab.model';

/**
 * Configuration mapping route paths to tab metadata.
 * Used to determine tab title, icon, and section when opening a new tab.
 */
export const ROUTE_TAB_CONFIG: Record<string, RouteTabConfig> = {
  // Questions section (admin-only)
  '/dashboard/questions/pro-list': {
    title: 'NAVBAR.PRO',
    icon: 'icon-insert-template',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/question-list': {
    title: 'NAVBAR.QUESTIONS',
    icon: 'icon-list1',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/question-groups': {
    title: 'NAVBAR.QUESTION-GROUPS',
    icon: 'icon-price-tags',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/dimensions': {
    title: 'NAVBAR.DIMENSIONS',
    icon: 'bi bi-rulers',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/factors': {
    title: 'NAVBAR.FACTORS',
    icon: 'icon-equalizer',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/question-state-rules': {
    title: 'NAVBAR.STATE_RULES',
    icon: 'icon-database',
    section: 'questions',
    closable: true,
  },
  '/dashboard/questions/question-types': {
    title: 'NAVBAR.QUESTION-TYPES',
    icon: 'icon-cogs',
    section: 'questions',
    closable: true,
  },

  // Products section (admin-only)
  '/dashboard/products/products-list': {
    title: 'NAVBAR.PRODUCTS',
    icon: 'icon-cart',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/treatments-list': {
    title: 'NAVBAR.TREATMENTS',
    icon: 'bi bi-capsule-pill',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/plans-list': {
    title: 'NAVBAR.PLANS',
    icon: 'bi bi-music-player',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/exceptions-list': {
    title: 'NAVBAR.EXCEPTIONS',
    icon: 'bi bi-exclamation-diamond-fill',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/vouchers-list': {
    title: 'NAVBAR.VOUCHERS',
    icon: 'bi bi-bag-plus-fill',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/product-sun': {
    title: 'NAVBAR.PRODUCT_SUN',
    icon: 'bi bi-sun',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/catalog-health': {
    title: 'NAVBAR.CATALOG_HEALTH',
    icon: 'bi bi-clipboard2-pulse',
    section: 'products',
    closable: true,
  },
  '/dashboard/products/packaging-config': {
    title: 'Packaging',
    icon: 'bi bi-box-seam',
    section: 'products',
    closable: true,
  },

  // Questions section - Child routes (detail views)
  '/dashboard/questions/question-list/:id': {
    title: 'NAVBAR.QUESTIONS',
    icon: 'icon-list1',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/question-list',
  },
  '/dashboard/questions/question-groups/:id': {
    title: 'NAVBAR.QUESTION-GROUPS',
    icon: 'icon-price-tags',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/question-groups',
  },
  '/dashboard/questions/factors/:id': {
    title: 'NAVBAR.FACTORS',
    icon: 'icon-equalizer',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/factors',
  },
  '/dashboard/questions/question-state-rules/:id': {
    title: 'NAVBAR.STATE_RULES',
    icon: 'icon-database',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/question-state-rules',
  },
  '/dashboard/questions/question-types/:id': {
    title: 'NAVBAR.QUESTION-TYPES',
    icon: 'icon-cogs',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/question-types',
  },
  '/dashboard/questions/pro-list/:id': {
    title: 'NAVBAR.PRO',
    icon: 'icon-insert-template',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/pro-list',
  },
  '/dashboard/questions/pro-list/:id/edit-pro/:childProId': {
    title: 'NAVBAR.PRO',
    icon: 'icon-insert-template',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/pro-list',
  },
  '/dashboard/questions/pro-list/:id/edit-question/:childQuestionId': {
    title: 'NAVBAR.QUESTIONS',
    icon: 'icon-list1',
    section: 'questions',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/questions/pro-list',
  },

  // Products section - Child routes (detail views)
  '/dashboard/products/products-list/:id': {
    title: 'NAVBAR.PRODUCTS',
    icon: 'icon-cart',
    section: 'products',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/products/products-list',
  },
  '/dashboard/products/treatments-list/:id': {
    title: 'NAVBAR.TREATMENTS',
    icon: 'bi bi-capsule-pill',
    section: 'products',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/products/treatments-list',
  },
  '/dashboard/products/plans-list/:id': {
    title: 'NAVBAR.PLANS',
    icon: 'bi bi-music-player',
    section: 'products',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/products/plans-list',
  },
  '/dashboard/products/exceptions-list/:id': {
    title: 'NAVBAR.EXCEPTIONS',
    icon: 'bi bi-exclamation-diamond-fill',
    section: 'products',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/products/exceptions-list',
  },
  '/dashboard/products/vouchers-list/:id': {
    title: 'NAVBAR.VOUCHERS',
    icon: 'bi bi-bag-plus-fill',
    section: 'products',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/products/vouchers-list',
  },

  // Analyze section
  '/dashboard/analyze/report': {
    title: 'NAVBAR.RESULTS',
    icon: 'icon-insert-template',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/users': {
    title: 'NAVBAR.USERS',
    icon: 'icon-user3',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/compare': {
    title: 'NAVBAR.COMPARE',
    icon: 'icon-tools',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/data': {
    title: 'NAVBAR.DATA',
    icon: 'icon-database',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/orders': {
    title: 'NAVBAR.ORDERS',
    icon: 'icon-cart',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/elastic': {
    title: 'NAVBAR.ELASTIC',
    icon: 'bi bi-speedometer2',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/medications': {
    title: 'NAVBAR.MEDICATIONS',
    icon: 'bi bi-capsule',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/questionnaires': {
    title: 'NAVBAR.QUESTIONNAIRES',
    icon: 'bi bi-ui-radios',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/subscriptions': {
    title: 'NAVBAR.SUBSCRIPTION_ANALYTICS',
    icon: 'bi bi-graph-up-arrow',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/forecast': {
    title: 'Forecast Report',
    icon: 'bi bi-binoculars',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/duplicates': {
    title: 'Duplicate Patients',
    icon: 'bi bi-people-fill',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/exceptions': {
    title: 'Search by Exception',
    icon: 'bi bi-shield-exclamation',
    section: 'analyze',
    closable: true,
  },
  '/dashboard/analyze/answers': {
    title: 'Search by Answer',
    icon: 'bi bi-search',
    section: 'analyze',
    closable: true,
  },

  // Analyze section - Child routes (detail views)
  '/dashboard/analyze/users/:id': {
    title: 'NAVBAR.USERS',
    icon: 'icon-user3',
    section: 'analyze',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/analyze/users',
  },
  '/dashboard/analyze/compare/:id': {
    title: 'NAVBAR.COMPARE',
    icon: 'icon-tools',
    section: 'analyze',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/analyze/compare',
  },

  // Patients section
  '/dashboard/patients/patient-record': {
    title: 'NAVBAR.PATIENT_RECORD',
    icon: 'bi bi-person-vcard',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/patient-plans': {
    title: 'NAVBAR.PATIENT_PLANS',
    icon: 'bi bi-clipboard-heart-fill',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/plan-overrides': {
    title: 'NAVBAR.PLAN_OVERRIDES',
    icon: 'bi bi-arrow-repeat',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/webhooks': {
    title: 'NAVBAR.WEBHOOKS',
    icon: 'bi bi-motherboard',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/subscriptions': {
    title: 'NAVBAR.SUBSCRIPTIONS',
    icon: 'bi bi-list-check',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/orders': {
    title: 'NAVBAR.SUBSCRIPTION_ORDERS',
    icon: 'bi bi-list-check',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/operational-logs': {
    title: 'NAVBAR.OPERATIONAL_LOGS',
    icon: 'bi bi-journal-text',
    section: 'patients',
    closable: true,
  },
  '/dashboard/patients/flagged-orders': {
    title: 'NAVBAR.FLAGGED_ORDERS',
    icon: 'bi bi-flag-fill',
    section: 'patients',
    closable: true,
  },

  // Patients section - Child routes (detail views)
  // Note: /dashboard/patients/patient-record/:email routes are handled internally
  // by PatientRecordSearchComponent's own tabset, not by the main tab service

  '/dashboard/patients/subscriptions/:id': {
    title: 'NAVBAR.SUBSCRIPTIONS',
    icon: 'bi bi-list-check',
    section: 'patients',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/patients/subscriptions',
  },
  '/dashboard/patients/subscriptions/webhook/:id': {
    title: 'NAVBAR.WEBHOOKS',
    icon: 'bi bi-motherboard',
    section: 'patients',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/patients/subscriptions',
  },
  '/dashboard/patients/orders/:id': {
    title: 'NAVBAR.SUBSCRIPTION_ORDERS',
    icon: 'bi bi-list-check',
    section: 'patients',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/patients/orders',
  },
  '/dashboard/patients/webhooks/:id': {
    title: 'NAVBAR.WEBHOOKS',
    icon: 'bi bi-motherboard',
    section: 'patients',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/patients/webhooks',
  },
  '/dashboard/patients/flagged-orders/:id': {
    title: 'NAVBAR.FLAGGED_ORDERS',
    icon: 'bi bi-flag-fill',
    section: 'patients',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/patients/flagged-orders',
  },

  // Marketing section
  '/dashboard/marketing/ticket-templates': {
    title: 'NAVBAR.ZENDESK_TEMPLATES',
    icon: 'bi bi-yin-yang',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/marketing/patient-tickets': {
    title: 'NAVBAR.ZENDESK_TICKETS',
    icon: 'bi bi-lightning-charge',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/marketing/monday': {
    title: 'NAVBAR.MONDAY',
    icon: 'bi bi-headset',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/hooks': {
    title: 'NAVBAR.HOOKS',
    icon: 'bi bi-plug-fill',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/hooks/:id': {
    title: 'NAVBAR.HOOKS',
    icon: 'bi bi-plug-fill',
    section: 'marketing',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/hooks',
  },
  '/dashboard/klaviyo-events': {
    title: 'Klaviyo Events',
    icon: 'bi bi-envelope-paper',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/klaviyo-subscription': {
    title: 'Klaviyo Subscription Audit',
    icon: 'bi bi-person-lock',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/klaviyo-first-order-sync': {
    title: 'Klaviyo First Order Sync',
    icon: 'bi bi-calendar-check',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/marketing/zendesk-activity-logs': {
    title: 'NAVBAR.ZENDESK_ACTIVITY_LOGS',
    icon: 'bi bi-card-list',
    section: 'marketing',
    closable: true,
  },
  '/dashboard/marketing/zendesk-profile-activity-logs': {
    title: 'Zendesk Profile Activity',
    icon: 'bi bi-person-lines-fill',
    section: 'marketing',
    closable: true,
  },

  // Marketing section - Child routes (detail views)
  '/dashboard/marketing/ticket-templates/:id': {
    title: 'NAVBAR.ZENDESK_TEMPLATES',
    icon: 'bi bi-yin-yang',
    section: 'marketing',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/marketing/ticket-templates',
  },
  '/dashboard/marketing/patient-tickets/:id': {
    title: 'NAVBAR.ZENDESK_TICKETS',
    icon: 'bi bi-lightning-charge',
    section: 'marketing',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/marketing/patient-tickets',
  },
  '/dashboard/marketing/monday/:id': {
    title: 'NAVBAR.MONDAY',
    icon: 'bi bi-headset',
    section: 'marketing',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/marketing/monday',
  },

  // Admin section (admin-only)
  '/dashboard/admin/user-list': {
    title: 'NAVBAR.OPERATORS',
    icon: 'bi bi-person',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/orgs-list': {
    title: 'NAVBAR.ORGS',
    icon: 'bi bi-building',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/doctors-list': {
    title: 'NAVBAR.DOCTORS',
    icon: 'bi bi-hospital',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/programs-list': {
    title: 'NAVBAR.PROGRAMS',
    icon: 'bi bi-award',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/doctors-report': {
    title: 'Provider Patient Report',
    icon: 'bi bi-clipboard2-pulse',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/children-report': {
    title: 'Children Report',
    icon: 'bi bi-balloon',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/unattributed-referrals': {
    title: 'Unknown Doctor',
    icon: 'bi bi-person-exclamation',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/incomplete-pros-report': {
    title: 'Incomplete PROs',
    icon: 'bi bi-clipboard2-check',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/clinics-list': {
    title: 'Clinics',
    icon: 'bi bi-hospital',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/zendesk-sync': {
    title: 'Zendesk Sync',
    icon: 'bi bi-arrow-repeat',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/user-messages': {
    title: 'NAVBAR.MESSAGES',
    icon: 'bi bi-envelope',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/export': {
    title: 'NAVBAR.EXPORT',
    icon: 'bi bi-box-arrow-up',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/sync': {
    title: 'NAVBAR.SYNC',
    icon: 'bi bi-arrow-repeat',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/settings': {
    title: 'NAVBAR.SETTINGS',
    icon: 'icon-cog',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/redis-explorer': {
    title: 'Redis Explorer',
    icon: 'bi bi-database',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/fix-patient-plan-steps': {
    title: 'Fix Patient Plan Step IDs',
    icon: 'bi bi-wrench-adjustable',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/data-fixers': {
    title: 'Data Fixers',
    icon: 'bi bi-wrench-adjustable-circle',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/service-accounts': {
    title: 'Service Accounts',
    icon: 'bi bi-key',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/pro-orders': {
    title: 'Pro Orders',
    icon: 'bi bi-receipt',
    section: 'admin',
    closable: true,
  },
  '/dashboard/admin/system-check': {
    title: 'System Check',
    icon: 'bi bi-heart-pulse',
    section: 'admin',
    closable: true,
  },
  '/dashboard/app-builder': {
    title: 'App Builder',
    icon: 'bi bi-boxes',
    section: 'marketing',
    closable: true,
  },

  // Admin section - Child routes (detail views)
  '/dashboard/admin/user-list/:id': {
    title: 'NAVBAR.OPERATORS',
    icon: 'bi bi-person',
    section: 'admin',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/admin/user-list',
  },
  '/dashboard/admin/orgs-list/:id': {
    title: 'NAVBAR.ORGS',
    icon: 'bi bi-building',
    section: 'admin',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/admin/orgs-list',
  },
  '/dashboard/admin/doctors-list/:id': {
    title: 'NAVBAR.DOCTORS',
    icon: 'bi bi-hospital',
    section: 'admin',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/admin/doctors-list',
  },
  '/dashboard/admin/programs-list/:id': {
    title: 'NAVBAR.PROGRAMS',
    icon: 'bi bi-award',
    section: 'admin',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/admin/programs-list',
  },
  '/dashboard/admin/user-messages/:id': {
    title: 'NAVBAR.MESSAGES',
    icon: 'bi bi-envelope',
    section: 'admin',
    closable: true,
    isChildRoute: true,
    parentRoute: '/dashboard/admin/user-messages',
  },

  // AI section
  '/dashboard/ai/tool-gallery': {
    title: 'Tool Gallery',
    icon: 'bi bi-tools',
    section: 'ai',
    closable: true,
  },
  '/dashboard/admin/agent-instructions': {
    title: 'AI Instructions',
    icon: 'bi bi-robot',
    section: 'ai',
    closable: true,
  },
  '/dashboard/admin/agents': {
    title: 'AI Agents',
    icon: 'bi bi-person-badge',
    section: 'ai',
    closable: true,
  },
  '/dashboard/corpus': {
    title: 'Corpus Viewer',
    icon: 'bi bi-journal-richtext',
    section: 'ai',
    closable: true,
  },
  '/dashboard/claude-skills': {
    title: 'Claude Skills',
    icon: 'bi bi-stars',
    section: 'ai',
    closable: true,
  },

  // Development section
  '/dashboard/dev-stories': {
    title: 'Dev Stories',
    icon: 'bi bi-kanban',
    section: 'development',
    closable: true,
  },
  '/dashboard/e2e-tests': {
    title: 'E2E Tests',
    icon: 'bi bi-clipboard2-check',
    section: 'development',
    closable: true,
  },
  '/dashboard/bug-reports': {
    title: 'Bug Reports',
    icon: 'bi bi-bug',
    section: 'development',
    closable: true,
  },
  '/dashboard/cloud-builds': {
    title: 'Build History',
    icon: 'bi bi-hammer',
    section: 'development',
    closable: true,
  },
};

/**
 * Menu structure for the sidebar navigation.
 * Each item represents a section with optional children.
 */
export const MENU_ITEMS: MenuItem[] = [
  {
    key: 'questions',
    title: 'NAVBAR.QUESTIONS',
    icon: 'bi bi-ui-checks-grid',
    adminOnly: true,
    profiles: ['composer'],
    children: [
      { key: 'pro-list', title: 'NAVBAR.PRO', route: '/dashboard/questions/pro-list', icon: 'icon-insert-template' },
      { key: 'question-list', title: 'NAVBAR.QUESTIONS', route: '/dashboard/questions/question-list', icon: 'icon-list1' },
      { key: 'question-groups', title: 'NAVBAR.QUESTION-GROUPS', route: '/dashboard/questions/question-groups', icon: 'icon-price-tags' },
      { key: 'dimensions', title: 'NAVBAR.DIMENSIONS', route: '/dashboard/questions/dimensions', icon: 'bi bi-rulers' },
      { key: 'factors', title: 'NAVBAR.FACTORS', route: '/dashboard/questions/factors', icon: 'icon-equalizer' },
      { key: 'question-state-rules', title: 'NAVBAR.STATE_RULES', route: '/dashboard/questions/question-state-rules', icon: 'icon-database' },
      { key: 'question-types', title: 'NAVBAR.QUESTION-TYPES', route: '/dashboard/questions/question-types', icon: 'icon-cogs' },
    ],
  },
  {
    key: 'products',
    title: 'NAVBAR.PRODUCTS',
    icon: 'bi bi-cart3',
    adminOnly: true,
    profiles: ['composer'],
    children: [
      { key: 'products-list', title: 'NAVBAR.PRODUCTS', route: '/dashboard/products/products-list', icon: 'icon-cart' },
      { key: 'treatments-list', title: 'NAVBAR.TREATMENTS', route: '/dashboard/products/treatments-list', icon: 'bi bi-capsule-pill' },
      { key: 'plans-list', title: 'NAVBAR.PLANS', route: '/dashboard/products/plans-list', icon: 'bi bi-music-player' },
      { key: 'exceptions-list', title: 'NAVBAR.EXCEPTIONS', route: '/dashboard/products/exceptions-list', icon: 'bi bi-exclamation-diamond-fill' },
      { key: 'vouchers-list', title: 'NAVBAR.VOUCHERS', route: '/dashboard/products/vouchers-list', icon: 'bi bi-bag-plus-fill' },
      { key: 'product-sun', title: 'NAVBAR.PRODUCT_SUN', route: '/dashboard/products/product-sun', icon: 'bi bi-sun' },
      { key: 'catalog-health', title: 'NAVBAR.CATALOG_HEALTH', route: '/dashboard/products/catalog-health', icon: 'bi bi-clipboard2-pulse' },
      { key: 'packaging-config', title: 'Packaging', route: '/dashboard/products/packaging-config', icon: 'bi bi-box-seam' },
    ],
  },
  {
    key: 'analyze',
    title: 'NAVBAR.ANALYZE',
    icon: 'bi bi-bar-chart-line',
    children: [
      { key: 'report', title: 'NAVBAR.RESULTS', route: '/dashboard/analyze/report', icon: 'icon-insert-template', profiles: ['analyst', 'care-giver'] },
      { key: 'users', title: 'NAVBAR.USERS', route: '/dashboard/analyze/users', icon: 'icon-user3', profiles: ['analyst', 'care-giver', 'marketer'] },
      { key: 'compare', title: 'NAVBAR.COMPARE', route: '/dashboard/analyze/compare', icon: 'icon-tools', profiles: ['analyst', 'marketer'] },
      { key: 'data', title: 'NAVBAR.DATA', route: '/dashboard/analyze/data', icon: 'icon-database', profiles: ['analyst'] },
      { key: 'orders', title: 'NAVBAR.ORDERS', route: '/dashboard/analyze/orders', icon: 'icon-cart', profiles: ['analyst', 'operator', 'marketer'] },
      { key: 'elastic', title: 'NAVBAR.ELASTIC', route: '/dashboard/analyze/elastic', icon: 'bi bi-speedometer2', profiles: ['analyst'] },
      { key: 'medications', title: 'NAVBAR.MEDICATIONS', route: '/dashboard/analyze/medications', icon: 'bi bi-capsule', profiles: ['analyst', 'care-giver'] },
      { key: 'questionnaires', title: 'NAVBAR.QUESTIONNAIRES', route: '/dashboard/analyze/questionnaires', icon: 'bi bi-ui-radios', profiles: ['analyst', 'composer'] },
      { key: 'subscriptions', title: 'NAVBAR.SUBSCRIPTION_ANALYTICS', route: '/dashboard/analyze/subscriptions', icon: 'bi bi-graph-up-arrow', profiles: ['analyst', 'operator', 'marketer'] },
      { key: 'forecast', title: 'Forecast Report', route: '/dashboard/analyze/forecast', icon: 'bi bi-binoculars', profiles: ['analyst', 'operator'] },
      { key: 'duplicates', title: 'Duplicate Patients', route: '/dashboard/analyze/duplicates', icon: 'bi bi-people-fill', profiles: ['analyst', 'operator'] },
      { key: 'exceptions', title: 'Search by Exception', route: '/dashboard/analyze/exceptions', icon: 'bi bi-shield-exclamation', profiles: ['analyst', 'operator', 'care-giver'] },
      { key: 'answers', title: 'Search by Answer', route: '/dashboard/analyze/answers', icon: 'bi bi-search', profiles: ['analyst', 'operator', 'care-giver'] },
    ],
  },
  {
    key: 'patients',
    title: 'NAVBAR.PATIENTS',
    icon: 'bi bi-people',
    children: [
      { key: 'patient-record', title: 'NAVBAR.PATIENT_RECORD', route: '/dashboard/patients/patient-record', icon: 'bi bi-person-vcard', profiles: ['care-giver', 'operator'] },
      { key: 'patient-plans', title: 'NAVBAR.PATIENT_PLANS', route: '/dashboard/patients/patient-plans', icon: 'bi bi-clipboard-heart-fill', profiles: ['care-giver', 'operator'] },
      { key: 'plan-overrides', title: 'NAVBAR.PLAN_OVERRIDES', route: '/dashboard/patients/plan-overrides', icon: 'bi bi-arrow-repeat', profiles: ['care-giver', 'operator'] },
      { key: 'webhooks', title: 'NAVBAR.WEBHOOKS', route: '/dashboard/patients/webhooks', icon: 'bi bi-motherboard', profiles: ['operator'] },
      { key: 'subscriptions', title: 'NAVBAR.SUBSCRIPTIONS', route: '/dashboard/patients/subscriptions', icon: 'bi bi-list-check', profiles: ['care-giver', 'operator'] },
      { key: 'orders', title: 'NAVBAR.SUBSCRIPTION_ORDERS', route: '/dashboard/patients/orders', icon: 'bi bi-list-check', profiles: ['care-giver', 'operator'] },
      { key: 'operational-logs', title: 'NAVBAR.OPERATIONAL_LOGS', route: '/dashboard/patients/operational-logs', icon: 'bi bi-journal-text', profiles: ['operator'] },
      { key: 'flagged-orders', title: 'NAVBAR.FLAGGED_ORDERS', route: '/dashboard/patients/flagged-orders', icon: 'bi bi-flag-fill', profiles: ['care-giver', 'operator'] },
    ],
  },
  {
    key: 'marketing',
    title: 'NAVBAR.MARKETING',
    icon: 'bi bi-megaphone',
    children: [
      { key: 'ticket-templates', title: 'NAVBAR.ZENDESK_TEMPLATES', route: '/dashboard/marketing/ticket-templates', icon: 'bi bi-yin-yang', profiles: ['care-giver', 'marketer'] },
      { key: 'patient-tickets', title: 'NAVBAR.ZENDESK_TICKETS', route: '/dashboard/marketing/patient-tickets', icon: 'bi bi-lightning-charge', profiles: ['care-giver', 'marketer'] },
      { key: 'monday', title: 'NAVBAR.MONDAY', route: '/dashboard/marketing/monday', icon: 'bi bi-headset', profiles: ['marketer'] },
      { key: 'hooks', title: 'NAVBAR.HOOKS', route: '/dashboard/hooks', icon: 'bi bi-plug-fill', profiles: ['operator'] },
      { key: 'klaviyo-events', title: 'Klaviyo Events', route: '/dashboard/klaviyo-events', icon: 'bi bi-envelope-paper', profiles: ['marketer'] },
      { key: 'klaviyo-subscription', title: 'Klaviyo Subscription Audit', route: '/dashboard/klaviyo-subscription', icon: 'bi bi-person-lock', profiles: ['marketer', 'operator'] },
      { key: 'klaviyo-first-order-sync', title: 'Klaviyo First Order Sync', route: '/dashboard/klaviyo-first-order-sync', icon: 'bi bi-calendar-check', profiles: ['marketer', 'operator'] },
      { key: 'app-builder', title: 'App Builder', route: '/dashboard/app-builder', icon: 'bi bi-boxes', profiles: ['marketer'] },
      { key: 'zendesk-activity-logs', title: 'NAVBAR.ZENDESK_ACTIVITY_LOGS', route: '/dashboard/marketing/zendesk-activity-logs', icon: 'bi bi-card-list', profiles: ['marketer', 'operator'] },
      { key: 'zendesk-profile-activity-logs', title: 'Zendesk Profile Activity', route: '/dashboard/marketing/zendesk-profile-activity-logs', icon: 'bi bi-person-lines-fill', profiles: ['marketer', 'operator'] },
    ],
  },
  {
    key: 'admin',
    title: 'NAVBAR.ADMIN',
    icon: 'bi bi-gear',
    adminOnly: true,
    children: [
      { key: 'user-list', title: 'NAVBAR.OPERATORS', route: '/dashboard/admin/user-list', icon: 'bi bi-person' },
      { key: 'orgs-list', title: 'NAVBAR.ORGS', route: '/dashboard/admin/orgs-list', icon: 'bi bi-building' },
      { key: 'doctors-list', title: 'NAVBAR.DOCTORS', route: '/dashboard/admin/doctors-list', icon: 'bi bi-hospital' },
      { key: 'programs-list', title: 'NAVBAR.PROGRAMS', route: '/dashboard/admin/programs-list', icon: 'bi bi-award' },
      { key: 'doctors-report', title: 'Provider Patient Report', route: '/dashboard/admin/doctors-report', icon: 'bi bi-clipboard2-pulse' },
      { key: 'children-report', title: 'Children Report', route: '/dashboard/admin/children-report', icon: 'bi bi-balloon' },
      { key: 'unattributed-referrals', title: 'Unknown Doctor', route: '/dashboard/admin/unattributed-referrals', icon: 'bi bi-person-exclamation' },
      { key: 'incomplete-pros-report', title: 'Incomplete PROs', route: '/dashboard/admin/incomplete-pros-report', icon: 'bi bi-clipboard2-check' },
      { key: 'clinics-list', title: 'Clinics', route: '/dashboard/admin/clinics-list', icon: 'bi bi-hospital' },
      { key: 'zendesk-sync', title: 'Zendesk Sync', route: '/dashboard/admin/zendesk-sync', icon: 'bi bi-arrow-repeat' },
      { key: 'user-messages', title: 'NAVBAR.MESSAGES', route: '/dashboard/admin/user-messages', icon: 'bi bi-envelope', profiles: ['care-giver'] },
      { key: 'export', title: 'NAVBAR.EXPORT', route: '/dashboard/admin/export', icon: 'bi bi-box-arrow-up' },
      { key: 'sync', title: 'NAVBAR.SYNC', route: '/dashboard/admin/sync', icon: 'bi bi-arrow-repeat' },
      { key: 'settings', title: 'NAVBAR.SETTINGS', route: '/dashboard/admin/settings', icon: 'bi bi-gear' },
      { key: 'redis-explorer', title: 'Redis Explorer', route: '/dashboard/admin/redis-explorer', icon: 'bi bi-database' },
      { key: 'fix-patient-plan-steps', title: 'Fix Patient Plan Step IDs', route: '/dashboard/admin/fix-patient-plan-steps', icon: 'bi bi-wrench-adjustable' },
      { key: 'data-fixers', title: 'Data Fixers', route: '/dashboard/admin/data-fixers', icon: 'bi bi-wrench-adjustable-circle' },
      { key: 'pro-orders', title: 'Pro Orders', route: '/dashboard/admin/pro-orders', icon: 'bi bi-receipt' },
      { key: 'service-accounts', title: 'Service Accounts', route: '/dashboard/admin/service-accounts', icon: 'bi bi-key' },
      { key: 'system-check', title: 'System Check', route: '/dashboard/admin/system-check', icon: 'bi bi-heart-pulse' },
    ],
  },
  {
    key: 'ai',
    title: 'AI',
    icon: 'bi bi-robot',
    children: [
      { key: 'tool-gallery', title: 'Tool Gallery', route: '/dashboard/ai/tool-gallery', icon: 'bi bi-tools', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
      { key: 'agent-instructions', title: 'AI Instructions', route: '/dashboard/admin/agent-instructions', icon: 'bi bi-robot' },
      { key: 'agents', title: 'AI Agents', route: '/dashboard/admin/agents', icon: 'bi bi-person-badge' },
      { key: 'corpus', title: 'Corpus Viewer', route: '/dashboard/corpus', icon: 'bi bi-journal-richtext', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
      { key: 'claude-skills', title: 'Claude Skills', route: '/dashboard/claude-skills', icon: 'bi bi-stars', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
    ],
  },
  {
    key: 'development',
    title: 'Development',
    icon: 'bi bi-code-square',
    children: [
      { key: 'dev-stories', title: 'Dev Stories', route: '/dashboard/dev-stories', icon: 'bi bi-kanban', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
      { key: 'bug-reports', title: 'Bug Reports', route: '/dashboard/bug-reports', icon: 'bi bi-bug', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
      { key: 'e2e-tests', title: 'E2E Tests', route: '/dashboard/e2e-tests', icon: 'bi bi-clipboard2-check', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
      { key: 'cloud-builds', title: 'Build History', route: '/dashboard/cloud-builds', icon: 'bi bi-hammer', profiles: ['operator', 'analyst', 'care-giver', 'composer', 'marketer'] },
    ],
  },
];

/**
 * Default route when no tabs are open
 */
export const DEFAULT_ROUTE = '/dashboard/home';

/**
 * Storage key for persisting tab state in localStorage
 */
export const TAB_STORAGE_KEY = 'mdi_tab_state';
